import React from 'react';
import {
  Box, Button, Container, Stack, Typography,
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  Icons, useApiClient, useFetch, ZSpinner,
} from '@marageti/z4-lib';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import { TripReviewImage } from '../../trip-review-submitted/trip-review-submit-view';

const buttonStyles = {
  my: '40px',
  width: {
    mobile: '100%',
    desktop: '30%',
  },
  mx: {
    desktop: '10px',
    mobile: '0px',
  },
};

const CancelTripHeader = ({ onBackClick }: { onBackClick: () => void }) => (
  <Stack
    direction="row"
    alignItems="flex-start"
  >
    <Box alignSelf="self-start">
      <Button
        aria-label="back to trip"
        onClick={onBackClick}
        sx={{ padding: '0px 16px 0px 0px', minWidth: '0px' }}
      >
        <Icons.ArrowLeft sx={{
          padding: '0px', margin: '0px', width: '18px', height: '18px',
        }}
        />
      </Button>
    </Box>
    <Typography variant="h4" width="100%" textAlign="center" pr="40px">
      Thank You
    </Typography>
  </Stack>
);

const TripCancelSuccess = () => {
  const navigate = useNavigate();
  const apiClient = useApiClient();
  const { tripRequestId } = useParams();
  const { data: trip, isLoading: tripLoading } = useFetch<TripRequest>(apiClient.tripRequestsClient.getTripRequest, [tripRequestId], !!tripRequestId);
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const navigateBack = () => {
    const backUrl = params.get('cancel-all') === 'true' ? -2 : -1;
    navigate(backUrl);
  };

  if (tripLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        sx={{
          padding: 0,
          margin: 0,
        }}
      >
        <ZSpinner />
      </Box>
    );
  }

  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          py: { desktop: 6.5, mobile: 3.5 },
          width: { desktop: '850px' },
          margin: { desktop: '0 auto 56px' },
          height: '100%',
        }}
      >
        <CancelTripHeader onBackClick={navigateBack} />
        <Box alignItems="left" mt="48px">
          <Stack spacing={3}>
            <TripReviewImage
              isLoading={tripLoading}
              photoId={trip?.photoId}
            />
            <div>
              <Typography variant="h3">
                Your request has been cancelled.
              </Typography>
              <Typography variant="body" mt="11px">
                We are sorry to hear that you have decided to cancel your trip with us. We understand that circumstances can change, and we respect your decision.
                If there is anything we can assist you with, please do not hesitate to reach out to us.
                <br />
                <br />
                Please be advised that our cancellation policy and terms and conditions apply to all cancellations.
                <br />
                <br />
                We hope to have the opportunity to serve you in the future and provide you with a memorable travel experience.
              </Typography>
            </div>
          </Stack>
        </Box>
        <Box display="flex" justifyContent="center">
          <Button variant="contained" sx={buttonStyles} onClick={navigateBack}>Close</Button>
        </Box>
      </Box>
    </Container>
  );
};
export default TripCancelSuccess;
